/**
 * BL-1417: "Image or video" pages (typeId 16) created after this day render only
 * their WYSIWYG body. Pages created on or before it keep the auto-rendered image/video.
 */
export const IMAGE_OR_VIDEO_AUTO_MEDIA_CUTOFF = '2026-09-01';

/**
 * Whether a node created at `created` predates the end of the cutoff day.
 * Drupal JSON:API serializes `created` as RFC3339 in the site's default timezone,
 * so the leading YYYY-MM-DD is already the site-local day. A missing or unreadable
 * date keeps the legacy rendering so existing pages never lose their media.
 *
 * @param   {string|number|undefined} created - node created date (RFC3339 string or unix seconds)
 * @returns {boolean}
 */
export function isCreatedOnOrBeforeAutoMediaCutoff(created) {
    const day = createdDay(created);

    return !day || day <= IMAGE_OR_VIDEO_AUTO_MEDIA_CUTOFF;
}

function createdDay(created) {
    if (typeof created === 'string' && /^\d{4}-\d{2}-\d{2}/.test(created)) return created.slice(0, 10);

    const date = typeof created === 'number' ? new Date(created * 1000) : undefined;

    return date && !Number.isNaN(date.getTime()) ? date.toISOString().slice(0, 10) : undefined;
}
